import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import "./LandingMotivationSection.css";

const MOTIVATION_ITEMS = [
  {
    icon: <EmojiEventsOutlinedIcon />,
    title: "Ачивки за лучший результат",
    desc: "Тренажёр показывает, кто ответил лучше всех. Отметьте лидеров — публичное признание мотивирует сильнее, чем сухой отчёт.",
  },
  {
    icon: <CardGiftcardOutlinedIcon />,
    title: "Подарки за активность",
    desc: "Завершил сценарий, прошёл тренажёр без ошибок, первым освоил новую тему — повод для поощрения от HR или руководителя.",
  },
  {
    icon: <LeaderboardOutlinedIcon />,
    title: "Соревновательный дух",
    desc: "Сравнение результатов внутри отдела подстёгивает участие: команда стремится не отставать и повторять успех лучших.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Вовлечение без давления",
    desc: "Обучение в привычном мессенджере снижает барьер входа — сотрудники участвуют охотнее, чем в формальной LMS.",
  },
];

export default function LandingMotivationSection() {
  return (
    <section
      id="motivation"
      className="landing-band landing-band--motivation landing-section landing-section--motivation"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="05 · Мотивация"
          title="Не только обучение — ещё и вовлечение команды"
          desc="MOGAME можно использовать как инструмент мотивации: ачивки за лучший результат в тренажёре, поощрения за активное прохождение сценариев и участие в обучении."
        />

        <div className="landing-band__panel landing-band__panel--motivation">
          <p className="landing-motivation__intro">
            HR и руководители видят в аналитике, кто прошёл программу и как
            справился с тренажёром — и могут отметить лучших: ачивкой,
            благодарностью в чате или небольшим подарком за активность.
          </p>

          <div className="landing-motivation__grid">
            {MOTIVATION_ITEMS.map(({ icon, title, desc }) => (
              <article className="landing-motivation-card" key={title}>
                <div className="landing-motivation-card__icon">{icon}</div>
                <h3 className="landing-motivation-card__title">{title}</h3>
                <p className="landing-motivation-card__desc">{desc}</p>
              </article>
            ))}
          </div>

          <div className="landing-motivation__example">
            <span className="landing-motivation__example-badge">Пример</span>
            <p>
              Отдел продаж проходит тренажёр по продукту. Трое сотрудников
              набрали 100% — HR публикует в корпоративном чате «Ачивку недели» и
              вручает небольшой приз. Остальные видят пример и охотнее
              подключаются к следующему обучению.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
